module.exports = __webpack_public_path__ + "img/banner_stationery.6d90303e.png";